import { useGlobal } from '@/utils/useGlobal';
import styles from './index.module.scss';
import EcoImg from 'eco-design/base/eco-img';

export default function ProductIntroduction() {
    const { useLang } = useGlobal();
    const { t } = useLang('PoweroceanPlus.ProductIntroduction');

    return (
        <div className={`${styles.productIntroduction}`}>
            <h2 className="product-title">{t('title')}</h2>
            <div className="desc">{t('desc')}</div>

            <div className="text-box">
                <div className="worp">
                    <div className="worp-item">
                        <h3 className="item-title first-item-title">{t('item_title1')}</h3>
                        <div className="item-desc">{t('item_desc1')}</div>
                    </div>
                    <div className="worp-item">
                        <h3 className="item-title">{t('item_title2')}</h3>
                        <div className="item-desc">{t('item_desc2')}</div>
                    </div>
                </div>
            </div>
            <div className="img-box">
                <div className="scroller-box">
                    <div className="img-item">
                        <EcoImg
                            pc="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717576768532/House-tuya.jpg"
                            pad="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717576779786/HouseMO-tuya.jpg"
                            alt={t('img_title1')}
                        />
                        <div className="item-title">{t('img_title1')}</div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export const getStaticProps = async () => {
    return {
        props: {},
    };
};
